import React from "react";
import styles from "./Destinations2.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations2 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Keep the mosaic layout limit
  const displayItems = destinations.slice(0, 5);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Explore The World</h2>
          <p className={styles.subheading}>Curated destinations just for you</p>
        </div>

        <div className={styles.mosaicGrid}>
          {displayItems.map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.mosaicItem}>
                <img
                  src={imageUrl}
                  alt={dest?.name || "Destination"}
                  className={styles.image}
                  onError={(e) => {
                    e.target.src = fallbackImage;
                  }}
                />

                <div className={styles.overlay}>
                  <span className={styles.tag}>Discover</span>
                  <h3 className={styles.destName}>
                    {dest?.name || "Explore Destination"}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations2;